import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    bottomPadding10: {
        paddingBottom: 10,
    },

    treePanel: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.default,
    },

    treeBlock: {
        flexGrow: 1,
        overflow: 'auto',
    },

    splitPane: {
        '& .Resizer': {
            height: 5,
            cursor: 'row-resize',
        }
    },

    infoPanel: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        backgroundColor: theme.palette.background.default,
    },

});

export default style;
